import React from "react";

interface IconProps {
    className?: string;
  }

const LayoutCenterIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width="258px"
    height="200px"
    viewBox="0 0 258 200"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Group 5</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-5" transform="translate(0.4911, 0)">
        <rect id="Rectangle" stroke="#CCCCCC" strokeWidth="12" fill="#FFFFFF" x="6" y="6" width="244.603774" height="188" rx="18" />
      </g>
    </g>
  </svg>
);

export default LayoutCenterIcon;
